// eslint-disable-next-line import/no-extraneous-dependencies

import {
  GET_LOCALIZATION_REQUESTING,
  GET_LOCALIZATION_SUCCESS,
  RESET_LOCALIZATION_ISFETCHING
} from './constants';

export const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_LOCALIZATION_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case GET_LOCALIZATION_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_LOCALIZATION_SUCCESS: {
      const data = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
